import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgC2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 170,
	height: 230,
	viewBox: "0 0 170 230",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6073_1280)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 170,
					height: 230,
					rx: 8,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M60.5741 143.8C55.5607 143.8 51.2941 142.973 47.7741 141.32C44.3074 139.613 41.6141 137.16 39.6941 133.96C37.7741 130.707 36.7074 126.76 36.4941 122.12C36.4407 119.933 36.4141 117.587 36.4141 115.08C36.4141 112.573 36.4407 110.173 36.4941 107.88C36.7074 103.293 37.7741 99.4 39.6941 96.2C41.6674 92.9467 44.4141 90.4667 47.9341 88.76C51.4541 87.0533 55.6674 86.2 60.5741 86.2C64.1474 86.2 67.4007 86.6533 70.3341 87.56C73.2674 88.4667 75.8007 89.7733 77.9341 91.48C80.0674 93.1867 81.7207 95.1867 82.8941 97.48C84.0674 99.7733 84.7074 102.333 84.8141 105.16C84.8141 105.64 84.6274 106.04 84.2541 106.36C83.9341 106.68 83.5341 106.84 83.0541 106.84H73.9341C73.2941 106.84 72.7874 106.68 72.4141 106.36C72.0407 106.04 71.7474 105.507 71.5341 104.76C70.7341 101.613 69.4007 99.4533 67.5341 98.28C65.6674 97.1067 63.3474 96.52 60.5741 96.52C57.2674 96.52 54.6541 97.4267 52.7341 99.24C50.8141 101.053 49.7741 104.067 49.6141 108.28C49.4541 112.653 49.4541 117.133 49.6141 121.72C49.7741 125.933 50.8141 128.947 52.7341 130.76C54.6541 132.573 57.2674 133.48 60.5741 133.48C63.3474 133.48 65.6674 132.893 67.5341 131.72C69.4541 130.493 70.7874 128.333 71.5341 125.24C71.7474 124.44 72.0407 123.907 72.4141 123.64C72.7874 123.32 73.2941 123.16 73.9341 123.16H83.0541C83.5341 123.16 83.9341 123.32 84.2541 123.64C84.6274 123.96 84.8141 124.36 84.8141 124.84C84.7074 127.667 84.0674 130.227 82.8941 132.52C81.7207 134.813 80.0674 136.813 77.9341 138.52C75.8007 140.227 73.2674 141.533 70.3341 142.44C67.4007 143.347 64.1474 143.8 60.5741 143.8ZM93.3228 143C92.7361 143 92.2561 142.813 91.8828 142.44C91.5095 142.067 91.3228 141.587 91.3228 141V136.2C91.3228 135.773 91.4295 135.213 91.6428 134.52C91.9095 133.773 92.4695 133.053 93.3228 132.36L103.883 121.88C107.776 118.893 110.923 116.36 113.323 114.28C115.776 112.2 117.589 110.307 118.763 108.6C119.936 106.893 120.523 105.24 120.523 103.64C120.523 101.56 119.936 99.8533 118.763 98.52C117.643 97.1333 115.803 96.44 113.243 96.44C111.536 96.44 110.096 96.8133 108.923 97.56C107.803 98.2533 106.923 99.1867 106.283 100.36C105.643 101.533 105.216 102.813 105.003 104.2C104.843 104.893 104.496 105.373 103.963 105.64C103.483 105.907 102.976 106.04 102.443 106.04H93.9628C93.4295 106.04 93.0028 105.88 92.6828 105.56C92.3628 105.187 92.2028 104.787 92.2028 104.36C92.2561 101.907 92.7628 99.5867 93.7228 97.4C94.7361 95.2133 96.1495 93.2667 97.9628 91.56C99.7761 89.8533 101.963 88.52 104.523 87.56C107.083 86.5467 109.989 86.04 113.243 86.04C117.723 86.04 121.483 86.7867 124.523 88.28C127.563 89.72 129.856 91.72 131.403 94.28C132.949 96.84 133.723 99.8 133.723 103.16C133.723 105.72 133.189 108.093 132.123 110.28C131.109 112.467 129.616 114.573 127.643 116.6C125.669 118.573 123.323 120.627 120.603 122.76L111.163 132.2H132.923C133.509 132.2 133.989 132.387 134.363 132.76C134.736 133.133 134.923 133.613 134.923 134.2V141C134.923 141.587 134.736 142.067 134.363 142.44C133.989 142.813 133.509 143 132.923 143H93.3228Z",
					fill: "#E2330A"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48.5,
					cy: -15.5,
					r: 56.5,
					fill: "#ED8B88"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 79.5,
					cy: 240.5,
					r: 59.5,
					fill: "#ED8B88"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 169,
			height: 229,
			rx: 7.5,
			stroke: "#BBBFC7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6073_1280",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 170,
				height: 230,
				rx: 8,
				fill: "white"
			})
		}) })
	]
});
export default SvgC2;
